exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".certificado-modal-backdrop[data-v-42c67a9a]{position:fixed;inset:0;background:rgba(16,24,40,.68);display:flex;align-items:center;justify-content:center;padding:24px;z-index:1050}.certificado-modal[data-v-42c67a9a]{width:min(1100px,100%);max-height:calc(100vh - 48px);overflow:hidden;border-radius:16px}.certificado-modal-body[data-v-42c67a9a]{background:#f8fafc;overflow:auto;max-height:calc(100vh - 220px);text-align:center}.pdf-preview-stack[data-v-42c67a9a]{display:flex;flex-direction:column;gap:16px;align-items:center}.pdf-canvas-container[data-v-42c67a9a]{width:100%;padding:8px 0}", ""]);

// exports
